import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
	selector: 'app-sso-dialog',
	templateUrl: './sso-dialog.component.html',
	styleUrls: ['./sso-dialog.component.scss'],
})

export class SsoDialogComponent implements OnInit {
	ssoForm = this.formBuilder.group({
		ssoEnabled: ['', []],
		signInUrl: ['', []],
		idpEntityId: ['', []],
		signingCert: ['', []],
		idpType: ['', []]
	});
	signInUrl: string = '';
	idpEntityId: string = '';
	signingCert: string = '';
	entityId: string = '';
	replyUrl: string = '';
	ssoEnabledValue: boolean = false;
	idpType: string = '';

	showFormError: boolean = false;
	errMsg: string = "";
	errMsgStyle: any = { 'max-width': '500px' };

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public dialogRef: MatDialogRef<SsoDialogComponent>,
		private translateService: TranslateService,
		private domSanitizer: DomSanitizer,
		private matIconRegistry: MatIconRegistry,
		private formBuilder: FormBuilder,
		private spinnerService: SpinnerService
	) {
		this.matIconRegistry.addSvgIcon(
			'trash_can',
			this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/trash.svg")
		);
	}

	ngOnInit() {
		let product = this.data.product;
		product.service.getSsoData(this.data.account).then( ssoData => {
			this.replyUrl = ssoData.replyUrl;
			this.entityId = ssoData.entityId;
			this.ssoEnabledValue = ssoData.ssoEnabled;
			this.signInUrl = ssoData.signInUrl;
			this.signingCert = ssoData.signingCert;
			this.idpEntityId = ssoData.idpEntityId;
			this.idpType = ssoData.idpType;
		});
	}

	goToSSOHelp() {
		window.open(this.translateService.instant('integrations.sso.sso-help'));
	}

	onRemoveIntegration() {
		console.log("Remove the integration - when successful, close the dialog");
		let result =
		{
			remove: true
		}
		this.dialogRef.close( result );
	}

	onSave(event) {
		console.log("Save the changes to the integration - when successful, close the dialog");
		this.showFormError = false;
		let product = this.data.product;
		this.spinnerService.setSpinnerMessageByKey('spinnerMessages.updatingAccount');
		this.spinnerService.showSpinner();
		product.service.setSsoData( this.data.account, this.signInUrl, this.idpEntityId, this.signingCert,
			this.replyUrl, this.entityId, this.idpType, this.ssoEnabledValue ).then(res => {
				if ( res == true ) {
					let result =
					{
						setupComplete: true,
					}
					this.dialogRef.close(result);
				}
				this.spinnerService.hideSpinner();
			})
			.catch( err => {
				this.displayErrorBasedOnException( err );
				this.spinnerService.hideSpinner();
			});
	}

	onCancel(event) {
		this.dialogRef.close( );
	}

	displayErrorBasedOnException( err: any ) {
		let theMessage = '';
		console.error("Display this error to the user", err);
		if ( err.body && err.body.message ) {
			theMessage = err.body.message;
		}
		else if ( err.error && err.error.message ) {
			theMessage = err.error.message;
		}
		else {
			this.errMsg = this.translateService.instant('integrations.sso.error-saving-sso-config');
			this.showFormError = true;
			return;
		}

		this.errMsg = this.translateService.instant('integrations.sso.error-saving-sso-config');
		this.showFormError = true;
		if ( theMessage == undefined || theMessage.length == 0 )
			return;


		//add more specific messages
		if ( theMessage.indexOf("Invalid certificates") != -1 ) {
			this.errMsg += ": " + this.translateService.instant('integrations.sso.error-signing-certificates-invalid');
		}
		else if ( theMessage.indexOf("Invalid login URL") != -1 ) {

			this.errMsg += ": " + this.translateService.instant('integrations.sso.error-sign-in-url-invalid');
		}
		else {
			this.errMsg += ": " + theMessage;
		}
		console.log("This is the formated error", this.errMsg)
	}
}
